// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { PublicSecurityTypeFragment } from './public-security-type.fragment.generated';
export type OwnerPublicSecurityFragment = { __typename?: 'OwnerPublicSecurityDTO', description: string, id: number, ownerId: number, psCode: string | null, psEncryptedPassword: string | null, psIstatGroup: number | null, psKey: string | null, psWithRoomId: boolean, sendOnline: boolean, publicSecurityType: { __typename?: 'PublicSecurityTypeDTO', countryCode: string, id: number, printable: boolean, printableBlank: boolean, receipt: boolean, sendFile: boolean, sendOnline: boolean, type: Types.PublicSecurityTypeEnum } };

export const OwnerPublicSecurityFragment = gql`
    fragment OwnerPublicSecurity on OwnerPublicSecurityDTO {
  description
  id
  ownerId
  psCode
  psEncryptedPassword
  psIstatGroup
  psKey
  psWithRoomId
  sendOnline
  publicSecurityType {
    ...PublicSecurityType
  }
}
    ${PublicSecurityTypeFragment}`;
/* eslint-enable */